import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import useRoutesHelper from "../../../hooks/useRoutesHelper";

import { clearDepositStocks } from "../../../redux/reducer/inventory.reducer";
import { getDepositStocks } from "../../../redux/api/inventory.api";

import TableWidget from "../../../components/tables/TableWidget";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import {
  getInventoryDepositStocksTableData,
  inventoryDepositStocksTableHeader,
} from "./tableConfigs/depositStocksConfig";
import { inventoryRoutes } from "../../../router/routesConstants";

import DepositStocksActionButtons from "./components/DepositStocksActionButtons";
import ContentCard from "../../../components/misc/ContentCard";
import CustomButton from "../../../components/CustomButton";
import Text from "../../../styleguide/Text";
import { dateForDatabase } from "../../../utils/dateAndTime";

function Stocks() {
  const dispatch = useAppDispatch();
  const { routeParams } = useRoutesHelper();
  const { productCode, lot, dataExpirare } = routeParams || {};

  const {
    inventory: {
      depositStocks: {
        data: { stocuri, nrTotalStoc },
        isLoadingDepositStocks,
      },
    },
  } = useAppSelector((state) => ({
    inventory: state.inventory,
  }));

  const goToProductHistory = () => {
    return `/${inventoryRoutes.inventory}/${inventoryRoutes.depositStocks}/${
      inventoryRoutes.productHistory
    }?codProdus=${productCode}&lot=${lot}&dataExpirare=${dateForDatabase(
      dataExpirare,
    )}`;
  };

  useEffect(() => {
    return () => {
      dispatch(clearDepositStocks());
    };
  }, [dispatch]);

  const handleTableActions = (action: TableActions) => {
    if (action.tablePagination.page && action.tablePagination.rowsPerPage) {
      dispatch(
        getDepositStocks({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          alley: action.tableSearch?.alley,
          building: action.tableSearch?.building,
          cell: action.tableSearch?.cell,
          column: action.tableSearch?.column,
          island: action.tableSearch?.island,
          productCode: action.tableSearch?.productCode,
          productName: action.tableSearch?.productName,
          row: action.tableSearch?.row,
          shelf: action.tableSearch?.shelf,
          lot: action.tableSearch?.lot,
        }),
      );
    }
  };

  return (
    <>
      <TableWidget
        tableTitle={"Stocuri depozit"}
        tableHeaderData={inventoryDepositStocksTableHeader}
        tableItemsData={getInventoryDepositStocksTableData(stocuri)}
        totalItems={nrTotalStoc}
        tableLoading={isLoadingDepositStocks}
        handleTableActions={handleTableActions}
        ActionButtonsComponent={DepositStocksActionButtons}
        withGlobalSearch={false}
        withGlobalFilter={false}
        withTablePagination
      />
      {!isLoadingDepositStocks &&
        stocuri.length === 0 &&
        productCode &&
        lot &&
        dataExpirare && (
          <ContentCard cardBodyClassName="flex flex-wrap justify-between items-center gap-3">
            <Text variant="h2">
              Doriti sa cautati produs care nu este in stoc?
            </Text>
            <CustomButton
              variant="contained"
              color="primary"
              icon="HISTORY"
              tooltipTitle="Deschide istoricul produsului cautat."
              navigate={goToProductHistory()}>
              Istoric produs
            </CustomButton>
          </ContentCard>
        )}
    </>
  );
}

export default Stocks;
